import { Injectable, inject } from '@angular/core';

import { PrettyUrlPageViewDataProvider } from '@frontend/sports/routing/pretty-urls/feature';
import { trackingConstants } from '@frontend/sports/tracking/feature';
import { isNil } from 'lodash-es';

import { IPickTracking } from './pick-tracking.model';

@Injectable({ providedIn: 'root' })
export class PickSourceProvider {
    private readonly prettyUrlPageViewDataProvider = inject(PrettyUrlPageViewDataProvider);

    getTracking(): { [key: string]: string } {
        return {};
    }

    get(
        source: string,
        contentPosition?: number,
        isFallbackMarketEnabled?: boolean,
        marqueeName?: string,
        sitecoreTemplateId?: string,
        marqueeType?: string,
        trackingOptions?: { [key: string]: string },
        isAutomatedMarquee?: boolean,
        isInSheetView?: boolean,
    ): IPickTracking {
        const baseTracking: IPickTracking & { additional: { [key: string]: string } } = {
            source,
            additional: trackingOptions || {},
        };
        if (!isNil(contentPosition)) {
            baseTracking[trackingConstants.COMPONENT_CONTENT_POSITION] = contentPosition.toString();
        }

        if (!isNil(isAutomatedMarquee)) {
            baseTracking.additional[trackingConstants.MARQUEE_CONTENT_LOGIC] = isAutomatedMarquee ? 'default - automated' : 'default';
        }

        if (!isNil(marqueeName)) {
            baseTracking.additional[trackingConstants.MARQUEE_NAME] = marqueeName;
        }

        if (!isNil(sitecoreTemplateId)) {
            baseTracking.additional[trackingConstants.SITECORE_TEMPLATE_ID] = sitecoreTemplateId;
        }

        if (!isNil(marqueeType)) {
            baseTracking.additional[trackingConstants.MARQUEE_TYPE] = marqueeType;
        }

        if (isInSheetView) {
            baseTracking.additional[trackingConstants.COMPONENT_MODULE_NAME] = trackingConstants.SEE_ALL_OVERLAY;
            baseTracking.sheetviewSuffix = `/${trackingConstants.SEE_ALL_OVERLAY}`;
        }

        baseTracking.additional[trackingConstants.LOCATION_ID] = this.getLocationTrackData();

        return baseTracking;
    }

    getLocationTrackData(): string {
        return this.prettyUrlPageViewDataProvider.getPageName();
    }
}
